import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'dateFromNow', pure: true })
export class DateFromNowPipe implements PipeTransform {
  transform(value: string): string | null {
    return value ? DateTime.fromISO(value).toRelative() : '';
  }
}
